import { Link } from "react-router-dom";
import { Wrench, Truck, Tag, Users, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HomeownerStrip() {
  return (
    <section className="border-b border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid items-center gap-8 rounded-xl border border-slate-200 bg-slate-50 p-8 lg:grid-cols-3 lg:p-10">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-sky-700"><Users className="h-4 w-4" /> Open Access</span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-slate-900 sm:text-3xl">HVAC Equipment for Homeowners & Trade</h2>
            <p className="mt-3 max-w-2xl text-slate-600">
              You don't have to be a contractor to buy from CA HVAC Direct. We make quality HVAC equipment accessible to
              homeowners and professionals. Depending on the equipment and local requirements, professional installation
              may be required or recommended — and we can help.
            </p>
          </div>
          <div className="lg:justify-self-end">
            <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800"><Link to="/shop">Start Shopping <ArrowRight className="h-4 w-4" /></Link></Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ServiceStrips() {
  const items = [
    { icon: Truck, title: "Local Delivery", text: "Distance-based local delivery within our service area. Availability and timing confirmed after your order.", to: "/support", cta: "How delivery works", tone: "cool" },
  ];
  return (
    <section className="border-b border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {items.map((it) => {
            const Icon = it.icon;
            const warm = it.tone === "warm";
            return (
              <div key={it.title} className="relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-[box-shadow,border-color] duration-200 hover:border-slate-300 hover:shadow-md">
                <span className={`h-1 w-full ${warm ? "bg-orange-500" : "bg-sky-600"} absolute inset-x-0 top-0`} />
                <span className={`mt-1 flex h-11 w-11 items-center justify-center rounded-sm ${warm ? "bg-orange-50 text-orange-600" : "bg-sky-50 text-sky-700"}`}><Icon className="h-5 w-5" /></span>
                <h3 className="mt-4 font-heading text-lg font-bold tracking-tight text-slate-900">{it.title}</h3>
                <p className="mt-2 flex-1 text-sm text-slate-600">{it.text}</p>
                <Link to={it.to} className={`mt-4 inline-flex items-center gap-1 text-sm font-semibold ${warm ? "text-orange-600 hover:text-orange-700" : "text-sky-700 hover:text-sky-800"}`}>{it.cta} <ArrowRight className="h-3.5 w-3.5" /></Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
